// Thư mục: src/services/adminChecklistService.js
import api from "@/api";

// Endpoint gốc (giả sử dùng chung với /api/checklist)
const BASE_URL = "/api/checklist";

/**
 * API service cho Admin quản lý Checklist
 */
export const AdminChecklistApi = {
  /**
   * Lấy lịch sử checklist (phân trang, có filter)
   * @param {object} params - { xeId?, taiXeId?, hasError?, page?, size?, sort? }
   * @returns {Promise<object>} Page<XeChecklistLogResponse>
   */
  getHistory(params = { page: 0, size: 10, sort: "thoiDiemThucHien,desc" }) {
    return api.get(`${BASE_URL}/history`, { params }).then((res) => res.data);
  },

  /**
   * Lấy chi tiết 1 log checklist (gồm các items)
   * @param {number} logId - ID của XeChecklistLog
   * @returns {Promise<object>} XeChecklistLogDetailResponse
   */
  getLogDetail(logId) {
    return api.get(`${BASE_URL}/log/${logId}`).then((res) => res.data);
  },

  // --- API PHỤ TRỢ (LẤY OPTIONS CHO FILTER) ---

  /**
   * Lấy danh sách Xe (ID, Biển số) cho dropdown
   */
  getXeOptions() {
    // Giả sử API của em là /api/xe/options (đã có từ module Xe)
    return api.get("/api/xe/options").then((res) => res.data);
  },

  /**
   * Lấy danh sách Tài xế (ID, Tên) cho dropdown
   */
  getTaiXeOptions() {
    // Giả sử API của em là /api/nguoi-dung/by-chuc-vu-code/TAI_XE (đã có từ module NguoiDung)
    return api
      .get("/api/nguoi-dung/by-chuc-vu-code/TAI_XE")
      .then((res) => res.data);
  },
};
